import { ArchiveFile } from '../types';

export const FALLBACK_READINGS: ArchiveFile[] = [
  {
    id: 'Individual_Readings/0262-060.html',
    name: 'Reading 262-60',
    type: 'html',
    path: 'Individual_Readings/0262-060.html',
    category: 'Cases 1-1000',
    summary: 'Readings 201-300',
    lastModified: '1934-01-19',
    size: '1.2 KB',
    description: 'Psychic Reading on spiritual laws and the Mind as the active Builder.'
  },
  {
    id: 'Individual_Readings/3976-015.html',
    name: 'Reading 3976-15',
    type: 'html',
    path: 'Individual_Readings/3976-015.html',
    category: 'Cases 3001-4000',
    summary: 'Readings 3901-4000',
    lastModified: '1934-01-19',
    size: '1.4 KB',
    description: 'Psychic Reading on the Earth changes, tectonic shifts, and future predictions.'
  }
];

export const FALLBACK_READING_CONTENT: Record<string, string> = {
  'Individual_Readings/0262-060.html': `<!DOCTYPE html>
<html>
<head><title>Reading 262-60</title></head>
<body>
<p>This psychic reading given by Edgar Cayce at the office of the Association, Psychic Research Department, on this 19th day of January, 1934.</p>
<p>P R E S E N T</p>
<p>Edgar Cayce; Gertrude Cayce, Conductor; Gladys Davis, Steno.</p>
<p>R E A D I N G</p>
<p>Gertrude Cayce: You will have before you the group gathered here, and their study of spiritual laws. You will give at this time the lesson on 'Mind is the Builder'.</p>
<p>Edgar Cayce: Yes, we have the group here, their minds and their purposes. In entering into the study of the spiritual laws, let each realize that indeed the mind is the builder.</p>
<p class="reading-paragraph">For, mind is the active builder. That which the mind dwells upon, that which is kept as the ideal of the individual, becomes the physical reality. If the mind is directed toward the spiritual things, the body and soul are lifted up.</p>
<p class="reading-paragraph">As has been given, there is the physical, the mental, the spiritual. The spirit is the life, the mind is the active builder, and the physical body is the result.</p>
<p class="reading-paragraph">Therefore, do not let thy heart be troubled. Keep the mind stayed upon the Christ ideal, for in Him is the light of the world, and that light will guide thy steps.</p>
</body>
</html>`,
  'Individual_Readings/3976-015.html': `<!DOCTYPE html>
<html>
<head><title>Reading 3976-15</title></head>
<body>
<p>This psychic reading given by Edgar Cayce at the office of the Association, Psychic Research Department, on this 19th day of January, 1934.</p>
<p>P R E S E N T</p>
<p>Edgar Cayce; Gertrude Cayce, Conductor; Gladys Davis, Steno.</p>
<p>R E A D I N G</p>
<p>Gertrude Cayce: You will have before you the body of Edgar Cayce and the records of the earth's future changes.</p>
<p>Edgar Cayce: Yes, we have the records of the changes of the earth's crust.</p>
<p class="reading-paragraph">As to the changes... The earth will be broken up in many places. The early portion will see a change in the physical aspect of the west coast of America. There will be open waters appear in the northern portions of Greenland. There will be new lands seen off the Caribbean Sea, and DRY land will appear.</p>
<p class="reading-paragraph">As to the southern coast of California, and the areas between Salt Lake and the southern portions of Nevada, these may expect, within the three months following greater activities in Vesuvius or Etna, an inundation by earthquakes.</p>
<p class="reading-paragraph">Where there has been those of a frigid or semi-tropical climate, these will become the more tropical, and moss and fern will grow. The pole shift will commence in the year 1998, ushering in the new cycle of light.</p>
</body>
</html>`
};

export const getFallbackReadings = (): ArchiveFile[] => {
  return FALLBACK_READINGS;
};

export const getFallbackReadingContent = (idOrPath: string): string | null => {
  const normalized = idOrPath.replace(/^\//, '');
  return FALLBACK_READING_CONTENT[normalized] || FALLBACK_READING_CONTENT[idOrPath] || null;
};
